export var verticalCentering = function () {
    return "\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n";
};
export var verticalHorizontalCentering = function () {
    return "\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  ";
};
export var linearOnHover = function (propertyName) {
    return "transition: " + propertyName + " 0.1s linear;";
};
export var iconBackground = function () {
    return "\n    display: inline-block;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 100%;\n    vertical-align: middle;\n  ";
};
export var iconBackgroundWithText = function () {
    return "\n    " + iconBackground() + "\n    margin-top: -3px\n  ";
};
export var Horizontal = function () {
    return "\n    align-items: center;\n    display: flex;\n\n    > *:not(:first-child) {\n      margin-left: 8px;\n    }\n  ";
};
//# sourceMappingURL=mixin.js.map